module.exports = __webpack_public_path__ + "static/media/shingleGeorgetownGrey.def14091.png";